// ============================================================
// BOOKING CONSTANTS
// ============================================================

export const PAGE_SIZE = 10;

export const STATUS_OPTIONS = [
  { value: 'all', label: 'Tous statuts' },
  { value: 'PAID', label: 'Payé' },
  { value: 'CONFIRMED', label: 'Confirmé' },
  { value: 'PENDING', label: 'En attente' },
  { value: 'QUOTE_REQUESTED', label: 'Devis' },
] as const;

export const TYPE_OPTIONS = [
  { value: 'all', label: 'Tous types' },
  { value: 'COWORKING', label: 'Coworking' },
  { value: 'PRIVATE_OFFICE', label: 'Bureau privatif' },
  { value: 'MEETING_ROOM', label: 'Salle de réunion' },
  { value: 'EVENT_SPACE', label: 'Évènementiel' },
] as const;

export const DATE_OPTIONS = [
  { value: 'all', label: 'Toutes périodes' },
  { value: 'today', label: "Aujourd'hui" },
  { value: '7days', label: '7 derniers jours' },
  { value: 'month', label: 'Ce mois-ci' },
  { value: 'year', label: 'Cette année' },
] as const;

export const PAYMENT_OPTIONS = [
  { value: 'all', label: 'Tous paiements' },
  { value: 'SingPay', label: 'SingPay' },
  { value: 'Virement', label: 'Virement' },
  { value: 'Chèque', label: 'Chèque' },
  { value: 'Espèces', label: 'Espèces' },
] as const;

export const LAYOUT_LABELS = {
  theatre: 'Théâtre',
  'u-shape': 'En U',
  cocktail: 'Cocktail',
  meeting: 'Réunion',
  classroom: 'Classe',
} as const;

export const SERVICE_CATEGORY_CONFIG = {
  equipment: {
    icon: 'Monitor',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
  },
  catering: {
    icon: 'Utensils',
    bg: 'bg-orange-50',
    text: 'text-orange-700',
  },
  support: {
    icon: 'Users',
    bg: 'bg-green-50',
    text: 'text-green-700',
  },
  setup: {
    icon: 'Settings',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
  },
} as const;

export const DOCUMENT_TYPE_CONFIG = {
  invoice: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    icon: 'CreditCard',
  },
  quote: {
    bg: 'bg-violet-50',
    text: 'text-violet-700',
    icon: 'FileText',
  },
  confirmation: {
    bg: 'bg-sky-50',
    text: 'text-sky-700',
    icon: 'CheckCircle2',
  },
  contract: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    icon: 'FileText',
  },
} as const;

export const PAYMENT_STATUS_CONFIG = {
  PAID: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    label: 'Payé',
  },
  PENDING: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    label: 'En attente',
  },
  FAILED: {
    bg: 'bg-rose-50',
    text: 'text-rose-700',
    label: 'Échec',
  },
  REFUNDED: {
    bg: 'bg-slate-100',
    text: 'text-slate-800',
    label: 'Remboursé',
  },
} as const;

export const TIMELINE_TYPE_CONFIG = {
  info: {
    color: 'text-sky-700',
    dotColor: 'bg-sky-500',
  },
  success: {
    color: 'text-emerald-700',
    dotColor: 'bg-emerald-500',
  },
  warning: {
    color: 'text-amber-700',
    dotColor: 'bg-amber-500',
  },
  error: {
    color: 'text-rose-700',
    dotColor: 'bg-rose-500',
  },
} as const;
